__turbopack_context__.v({
  "className": "zcoolxiaowei_cedf9e84-module__TVbVwG__className",
  "variable": "zcoolxiaowei_cedf9e84-module__TVbVwG__variable",
});
